export const extractVisitUrl = jsonLd => {
  return jsonLd['atlassian:visitUrl'];
};